

import { createClient } from '@supabase/supabase-js';


const supabaseUrl = process.env.REACT_APP_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_PUBLIC_SUPABASE_ANON;
export const supabase = createClient(supabaseUrl, supabaseAnonKey);